import { settings } from "../../../../settings/settings-util";
import { hasNoReason } from '../util/util';
import h from "virtual-dom/h";


export default class SurveyFreeformTextBuilder
{
    //#region Public Interface

    constructor(settings)
    {
        this._settings = settings;
    }

    initialize(store)
    {
        this._store = store;
    }

    buildFreeformText(textConfig)
    {
        const checkLength = (e) => { this.checkLength(e, textConfig.maxLength); };
        const freeformOnkeyup = (e) => { this.freeformOnkeyup(e, textConfig.maxLength);};
        const textClassName = this._settings.classNames.surveyFreeformText || settings.classNames.surveyFreeformText;
        const indexLocation = this._settings.stateLocations.Survey.SelectedReasonIndex || settings.stateLocations.Survey.SelectedReasonIndex;
        const attributes = { };
        const indexes = textConfig.disableUntilRadioIndexSelected;

        if (textConfig.disableUntilReasonGiven && hasNoReason(this._settings, this._store))
        {
            attributes.disabled = true;
        }

        const currentSelection = this.getSurveyState()[indexLocation];
        if(indexes && currentSelection && !indexes.includes(currentSelection)){
            attributes.disabled = true;
            this.clearExistingText();
        }

        return h("textarea",
        {
            className: textClassName,
            placeholder: textConfig.placeholder,
            ariaLabel: textConfig.placeholder,
            onkeyup: freeformOnkeyup,
            onpaste: checkLength,
            onkeydown: checkLength,
            attributes: attributes,
        });
    }

    //#endregion



    //#region Helper Methods

    freeformOnkeyup(e, maxLength)
    {
        this.checkLength(e, maxLength);
        this._store.dispatch({ type: "SURVEY_COMMENT_GIVEN", comment: e.target.value });
    }

    checkLength(e, maxLength)
    {
        let text = e.target.value;
        if (text.length > maxLength)
        {
            text = text.substring(0, maxLength);
            e.target.value = text;
        }
    }

    clearExistingText()
    {
        const existingText = this.getElementByClassNameFromSurvey(this._settings.classNames.surveyFreeformText);

        if (existingText) { existingText.value = ""; }
    }

    getSurveyState()
    {
        const base = this._settings.stateLocations.Survey.Base;

        return this._store.getState()[base];
    }

    getElementByClassNameFromSurvey(className)
    {
        const survey = document.getElementById(this.getSurveyId());

        return survey ? survey.getElementsByClassName(className)[0] : null;
    }

    getSurveyId()
    {
        return this.getSurveyState()[this._settings.stateLocations.Survey.SurveyId];
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/simple-feedback-overlay/src/builders/surveyFreeformTextBuilder.js